module.exports = ".text-gray {\n  display: block;\n  color: #6c757d; }\n"